import styled from "styled-components";

const A = styled.a`
  color: black;
  font-weight: bold;
  font-style: normal;
  text-decoration: none;
`;

export default A;